// extracted by mini-css-extract-plugin
module.exports = {"button":"PhotosLoadMore_button__3OoM3"};